import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {
    faEnvelope,
    faUnlock,
    faUser,
} from '@fortawesome/fontawesome-free-solid'
import PropTypes from 'prop-types';
import { login, signup } from '../helpers/registrationHelper';
import Errors from '../components/errors';
import Loading from '../components/Loading';
import moment from 'moment-with-locales-es6';

class Registration extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            isLoginPage: true,
            email: '',
            loading: false,
            redirectToDashboard: true,
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }


    componentDidMount() {
        window.addEventListener('load', () => {
            if(localStorage.user_id) {
                setTimeout(() => { 
                    this.setState({redirectToDashboard:  false})
                    this.handleLogin()
                }, 15000)
            }
        });
    }

    handleKeyPress(target) {
        if (target.charCode == 13) {
            this.handleLogin();
        }
    }

    handleChange(event) {
        this.setState({ [event.target.id]: event.target.value });
    }

    getLoginPage() {
        return (
            <div className="loginContainer">
                <div className="loginWrapper">
                    <h3>Login</h3>
                    <div className="inputContainer">
                        <div className="inputWrapper">
                            <input
                                className="inputPrimary"
                                id="email"
                                type="text"
                                placeholder="Email address"
                                onChange={this.handleChange}
                                disabled={this.state.loading}
                            />
                            <span className="focusInput"></span>
                            <span className="symbolInput">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </span>
                        </div>
                        <div className="inputWrapper">
                            <input
                                className="inputPrimary"
                                type="password"
                                id="password"
                                placeholder="Enter your password"
                                onChange={this.handleChange}
                                onKeyPress={this.handleKeyPress}
                                disabled={this.state.loading}
                            />
                            <span className="focusInput"></span>
                            <span className="symbolInput">
                                <FontAwesomeIcon icon={faUnlock} />
                            </span>
                        </div>
                    </div>
                    {this.state.errors && this.state.errors.length > 0 &&
                        <Errors errorsMsgs={this.state.errors} />
                    }
                    <div className="buttonContainer">
                        <button
                            className="primaryBtn"
                            onClick={this.handleLogin.bind(this)}
                            disabled={this.state.loading}
                        >
                            {
                                this.state.loading ? <Loading /> : "Login"
                            }
                        </button>
                    </div>
                    <span className="signUp" onClick={this.handleClick}>{"I don't have a We Care account"}</span>
                </div>
            </div>
        );
    }

    getSignupPage() {
        return (
            <div className="loginContainer">
                <div className="loginWrapper">
                    <h3>Registration</h3>
                    <div className="inputContainer">
                        <div className="inputWrapper">
                            <input className="inputPrimary" id="email" type="text" placeholder="Email address" onChange={this.handleChange} />
                            <span className="focusInput"></span>
                            <span className="symbolInput">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </span>
                        </div>
                        <div className="inputWrapper">
                            <input className="inputPrimary" id="password" type="password" placeholder="Enter your password" onChange={this.handleChange} />
                            <span className="focusInput"></span>
                            <span className="symbolInput">
                                <FontAwesomeIcon icon={faUnlock} />
                            </span>
                        </div>
                        <div className="inputWrapper">
                            <input className="inputPrimary" id="password_confirmation" type="password" placeholder="Confirm your password" onChange={this.handleChange} />
                            <span className="focusInput"></span>
                            <span className="symbolInput">
                                <FontAwesomeIcon icon={faUnlock} />
                            </span>
                        </div>
                        <div className="inputWrapper">
                            <input className="inputPrimary" type="text" id="name" placeholder="Username" onChange={this.handleChange} />
                            <span className="focusInput"></span>
                            <span className="symbolInput">
                                <FontAwesomeIcon icon={faUser} />
                            </span>
                        </div>
                    </div>
                    {this.state.errors && this.state.errors.length > 0 &&
                        <Errors errorsMsgs={this.state.errors} />
                    }
                    <div className="buttonContainer">
                        <button
                            className="primaryBtn"
                            onClick={this.handleSignup.bind(this)}
                            disabled={this.state.loading}
                        >
                            {
                                this.state.loading ? <Loading /> : "Signup"
                            }
                        </button>
                    </div>
                    <span className="signUp" onClick={this.handleClick}>I have a We Care account</span>
                </div>
            </div>
        );
    }

    handleLogin() {
        const params = { email: this.state.email, password: this.state.password }
        this.setState({ loading: true });
        login(params).then((data) => {
            if(data.data.errors) {
                this.setState( { errors: data.errors})
            } else if(data.headers.expiry && data.headers.client && data.headers.client && data.headers["access-token"]) {
                let lastLogin = moment()
                localStorage.setItem("expiry", data.headers.expiry);
                localStorage.setItem("uid", data.headers.uid);
                localStorage.setItem("client", data.headers.client);
                localStorage.setItem("accessToken", data.headers["access-token"]);
                localStorage.setItem("user_id", data.data.data.id);
                localStorage.setItem("name", data.data.data.name);
                localStorage.setItem("token_chat", data.data.data.token_jwt_chat);
                localStorage.setItem("lastLoginDate", lastLogin)
                localStorage.setItem("password", this.state.password)

                if(localStorage.user_id) {
                    setTimeout(() => { 
                        this.setState({redirectToDashboard:  false})
                        this.handleLogin()
                    }, 900000)
                }
                
                if(this.props.history.location.pathname === "/") {
                    this.props.history.push('/dashboard')
                }
            } else {
                this.setState({ loading: false, errors: ["No headers in received response from LOGIN_URL"] })
            }
        })
            .catch((error) => {
                this.setState({ loading: false, errors: error });
            })
    }

    handleSignup() {
        const params = {
            email: this.state.email,
            password: this.state.password,
            password_confirmation: this.state.password_confirmation,
            nickname: this.state.email,
            name: this.state.name
        }

        signup(params)
            .then((data) => {
                localStorage.setItem("expiry", data.headers.expiry);
                localStorage.setItem("uid", data.headers.uid);
                localStorage.setItem("client", data.headers.client);
                localStorage.setItem("accessToken", data.headers["access-token"]);
                localStorage.setItem("user_id", data.data.data.id);
                localStorage.setItem("name", data.data.data.name);
                localStorage.setItem("token_chat", data.data.data.token_jwt_chat);
                
                setTimeout(() => { 
                    this.setState({redirectToDashboard:  false})
                    this.handleLogin()
                }, 900000)
            
                if(this.props.history.location.pathname === "/") {
                    this.props.history.push('/dashboard')
                }
            })
            .catch((error) => {
                this.setState({ loading: false, errors: error })
            })
    }

    handleClick() {
        const loading = this.state.loading;
        if (!loading) {
            this.setState(prevState => ({
                isLoginPage: !prevState.isLoginPage, errors: null
            }));
        }
    }

    render() {
        return this.state.isLoginPage ? this.getLoginPage() : this.getSignupPage();
    }
}

Registration.propTypes = {
    history: PropTypes.object
};

export default Registration;


// WEBPACK FOOTER //
// ./src/containers/registration.js